import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=194874b0&"
import script from "./InfoView.vue?vue&type=script&lang=js&"
export * from "./InfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports